// IC-6935 - deep link from the Brello patient portal to the Brello mobile app.

export const BRELLO_ANDROID_PACKAGE = 'co.alliahealth.brello';

export const BRELLO_IOS_STORE_URL =
  'https://apps.apple.com/us/app/brello/id6747013845';

export const BRELLO_ANDROID_STORE_URL = `https://play.google.com/store/apps/details?id=${BRELLO_ANDROID_PACKAGE}&hl=en_US`;

type MobilePlatform = 'ios' | 'android' | 'other';

export const detectMobilePlatform = (): MobilePlatform => {
  const userAgent = navigator.userAgent || '';

  if (/android/i.test(userAgent)) {
    return 'android';
  }
  // iPadOS 13+ reports a desktop Safari user agent, so fall back to touch
  // points to tell an iPad apart from a Mac.
  if (
    /iPad|iPhone|iPod/.test(userAgent) ||
    (/Macintosh/.test(userAgent) && navigator.maxTouchPoints > 1)
  ) {
    return 'ios';
  }
  return 'other';
};

/**
 * Where the "Get the Brello App" nav button should send the patient.
 *
 * Android opens the installed app straight away and falls back to the Play
 * Store listing when it is missing. That only needs the package name, which we
 * already have.
 *
 * iOS cannot do the same from a plain App Store link - opening an installed app
 * needs either a Universal Link or a custom scheme registered by the Brello app
 * team. Until Allia Health give us one, iOS goes to the App Store listing.
 */
export const getBrelloAppUrl = (): string => {
  switch (detectMobilePlatform()) {
    case 'android':
      // No host, no scheme: with only a package name Android launches that
      // app's main screen. Adding a scheme here would make Android look for an
      // app that handles that scheme *with no address*, which resolves to
      // nothing and would send every patient to the store.
      return `intent://#Intent;package=${BRELLO_ANDROID_PACKAGE};S.browser_fallback_url=${encodeURIComponent(
        BRELLO_ANDROID_STORE_URL
      )};end`;
    case 'ios':
      return BRELLO_IOS_STORE_URL;
    default:
      return BRELLO_IOS_STORE_URL;
  }
};
